import { server } from "@/api";

const prefix = 'api/my-company'

/**
 * Get all members connected with any company user
 * @param {Object} [params] - Query parameters
 * @param {string} [params.status] - Filter by connection status
 * @param {string} [params.search] - Search term for filtering
 * @param {number} [params.page] - Page number for pagination
 * @param {number} [params.per_page] - Items per page
 * @returns {Promise} List of connected members
 */
export const getContacts = async (params = {}) => {
    return await server().get(`${prefix}/contacts`, { params });
}

/**
 * Get meetings related to company users
 * @param {Object} [params] - Query parameters
 * @param {string} [params.status] - Filter by meeting status: 'pending', 'accepted', 'declined', 'cancelled', 'in_progress', 'completed'
 * @param {string} [params.type] - Filter by meeting type: 'member_to_member', 'member_to_company'
 * @param {boolean} [params.upcoming] - Filter for upcoming meetings only
 * @param {number} [params.page] - Page number for pagination
 * @param {number} [params.per_page] - Items per page
 * @returns {Promise} List of meetings
 */
export const getMeetings = async (params = {}) => {
    return await server().get(`${prefix}/meetings`, { params });
}

/**
 * Get all company members
 * @param {Object} [params] - Query parameters
 * @param {string} [params.search] - Search term for filtering
 * @param {string} [params.role] - Filter by user role
 * @param {number} [params.page] - Page number for pagination
 * @param {number} [params.per_page] - Items per page
 * @returns {Promise} List of company members
 */
export const getMembers = async (params = {}) => {
    return await server().get(`${prefix}/members`, { params });
}

/**
 * Get company statistics
 * @returns {Promise} Company statistics including products, services, members, contacts, meetings, categories, certificates
 */
export const getStats = async () => {
    return await server().get(`${prefix}/stats`);
}

const myCompanyApi = {
    getContacts,
    getMeetings,
    getMembers,
    getStats
};

export default myCompanyApi;

